const ESCAPED: Record<string, string> = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
};

const escapeHtml = (text: string): string =>
    text.replace(/[&<>"']/g, (character) => ESCAPED[character]);

/**
 * A plain-text draft (written by the assistant) as the composer's HTML: escaped, so no tag, link or
 * image of the model's ever reaches the editor; one paragraph per block separated by a blank line,
 * a line break for a single newline.
 */
const draftToHtml = (text: string): string =>
    text
        .replace(/\r\n?/g, "\n")
        .trim()
        .split(/\n[ \t]*\n+/)
        .map((block) => `<p>${escapeHtml(block).split("\n").join("<br>")}</p>`)
        .join("");

export default draftToHtml;
